/** @jsx jsx */
import { Box, Flex, jsx } from "theme-ui";
import React from "react";
import CompanyLogo from "../../components/company/company-logo";
import RockitLink from "../../components/link/rockit-link";
import NavFooter from "../../components/navigation/nav-footer";
import Copyright from "../../components/copyright/copyright.component";

export type PageFooterProps = {};
export const PageFooter: React.FC<PageFooterProps> = ({}) => {
  return (
    <Box p={4} as="footer" bg="primary" mt={4}>
      <Flex variant="layout.box">
        <Flex
          variant="footer"
          sx={{
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <CompanyLogo />
          <NavFooter />
          <Flex sx={{ width: "40%", justifyContent: "center" }}>
            <Box mx={1}>
              <RockitLink sx={{ color: "white" }} to="/privacy">
                Privacy
              </RockitLink>
            </Box>
            <Box mx={1}>
              <RockitLink sx={{ color: "white" }} to="/contact">
                Contact
              </RockitLink>
            </Box>
          </Flex>

          <Copyright />
        </Flex>
      </Flex>
    </Box>
  );
};

export default PageFooter;
